import { Link } from 'react-router-dom';
import { categories, comics, featuredIds } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%20with%20warm%20cozy%20reading%20atmosphere%2C%20soft%20golden%20and%20peach%20color%20palette%2C%20bookshelves%20with%20comic%20books%2C%20comfortable%20reading%20nook%20with%20warm%20lighting%2C%20artistic%20stylized%20illustration%2C%20dreamy%20and%20inviting%20mood&width=1600&height=900&seq=hero-bg-hanmanwu&orientation=landscape"
        alt="韩漫屋 - 韩漫免费看 下拉式漫画大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="韩漫屋 - 韩漫免费看 下拉式漫画大全 韩国漫画在线"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          韩漫免费看
        </h1>
        <p className="text-base md:text-xl text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          下拉式漫画大全，韩国漫画在线。在韩漫屋享受韩漫免费看的乐趣，下拉式漫画大全与友好的韩国漫画在线界面，为您营造温馨舒适的阅读环境。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm whitespace-nowrap transition-all cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/20 hover:bg-white/30 text-white font-semibold rounded-full text-sm whitespace-nowrap transition-all backdrop-blur-sm cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">{comics.length}+</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">漫画作品</p>
          </div>
          <div className="w-px h-10 bg-white/30" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">8</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">分类板块</p>
          </div>
          <div className="w-px h-10 bg-white/30" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">100%</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">免费阅读</p>
          </div>
        </div>
      </div>
    </section>
  );
}